export { default } from 'next-flight-server-reference-proxy-loader?id=4082e526a56e5c283d7a8bfff0dca9a8e9a8d50388&name=default!'